import Zipcode from '@wwdev/zipcode';

Zipcode.init();
 